import ApiService from "@/common/api.service";

export const TraineeService = {
    create(params) {
        return ApiService.post("/trainingUpdate/add", params);
    },
    update(slug, params) {
        return ApiService.update("/trainingUpdate", slug, params);
    },
    delete(slug, params) {
        return ApiService.delete("trainingUpdate", slug, params);
    },
    traineeCourseByUpdateId(params) {
        return ApiService.get("/trainingUpdate/traineeCourseByUpdateId/" + params,);
    },
    searchTrainee(params) {
        return ApiService.query("/person/search", params);
    },
    async getTraineeList() {
        const res = await ApiService.get("/trainingUpdate");
        return res.data;
    },
    async getHraTraineeAssignList(params) {
        const res = await ApiService.get(`/trainingUpdate${params}`);
        return res.data;
    },
    async getNewTraineeAssignList(params) {
        const res = await ApiService.get(`/trainingUpdate/new-trainee-assigns${params}`);
        return res.data;
    },
    async getTraineeListWP(name, dates) {
        let filterbyDate = ""
        for (let i in dates) {
            filterbyDate += i + "=" + dates[i]
            // Object.keys(dates).length-1!==count &&(
            filterbyDate += '&'
        }
        filterbyDate += `name=${name}`

        const res = await ApiService.get(
            `/trainingUpdate?${filterbyDate}`
        );
        return res.data;
    },
    registerTrainee(params) {
        return ApiService.post("/trainingUpdate/registerNewTrainee", params);
    },
    async searchNewTrainee(params) {
        const res = await ApiService.query(
            "trainingUpdate/newTrainees/search",
            params
        );
        return res.data;
    },
    updateNewTraineeCourse(slug, params) {
        return ApiService.update(
            "/trainingUpdate/trainees/updateCourse",
            slug,
            params
        );
    },
    createNewTraineeCourse(params) {
        return ApiService.post("/trainingUpdate/trainees/addCourse", params);
    },
    async getNewTraineeCourseList() {
        const res = await ApiService.get("/trainingUpdate/trainees/courseHistory");
        return res.data;
    },
    async getNewTraineeCourseListWP(name, dates) {
        let filterbyDate = ""
        for (let i in dates) {
            filterbyDate += i + "=" + dates[i]
            // Object.keys(dates).length-1!==count &&(
            filterbyDate += '&'
        }
        filterbyDate += `name=${name}`

        const res = await ApiService.get(
            `/trainingUpdate/trainees/courseHistory?${filterbyDate}`
        );
        return res.data;
    },
    updateNewTrainee(slug, params) {
        return ApiService.update("/trainingUpdate/updateTrainee", slug, params);
    },
    async getTraineesList(params) {
        const res = await ApiService.get(`trainees/list${params}`);
        return res.data;
    },
    async getNewTraineesListWP(name) {
        const res = await ApiService.get(
            `/trainingUpdate/newTrainees/all?name=${name}`
        );
        return res.data;
    },
    completeTraineeCourse(params) {
        return ApiService.put("/trainingUpdate/course/completeCourse", params);
    },
    completeNewTraineeCourse(params) {
        return ApiService.put(
            "/trainingUpdate/newTrainee/course/completeCourse",
            params
        );
    },
    getTraineeStatus() {
        return ApiService.get("/traineeStatus");
    },
    completeTraineeCat2Course(params) {
        return ApiService.put("/trainingUpdate/course/completeCat2Course", params);
    },
    completeNewTCat2Course(params) {
        return ApiService.put(
            "/trainingUpdate/newTrainee/course/completeCat2Course",
            params
        );
    },
    generateQrCode(params) {
        return ApiService.post("/generateQrCode/scan", params);
    },
    async getTrainee(slug) {
        const resp = await ApiService.get(
            "/trainingUpdate/trainee/public/information/" + slug
        );
        return resp.data;
    },
    async getNewTrainee(slug) {
        const resp = await ApiService.get(
            "/trainingUpdate/newTrainee/public/information/" + slug
        );
        return resp.data;
    },
    async importTrainees(trainees) {
        const resp = await ApiService.post(`/trainees/imports`, trainees);
        return resp.data;
    },
    async sendEmail(params) {
        const resp = await ApiService.postFormData(`/trainees/send-email`, params);
        return resp.data;
    },
    async approveTrainees(slug, params) {
        return ApiService.update("/approve-trainees", slug, params);
    },
};
